import { Component, Input, input, viewChild } from '@angular/core';

import { Blast3DViewerComponent } from '../blast3-dviewer/blast3-dviewer.component';
import { GeologyModel } from '../blast3-dviewer/geology-model';

/**
 * Lazy loading wrapper for Blast3DViewerComponent.
 * This standalone component uses @defer to lazy load the Three.js heavy 3D viewer
 * only when needed, reducing the initial bundle size.
 */
@Component({
  selector: 'app-blast3-dviewer-lazy',
  standalone: true,
  imports: [Blast3DViewerComponent],
  template: `
    @defer (on viewport) {
      <app-blast3-dviewer [tirId]="tirId" [geologyModel]="geologyModel()" class="available-width"></app-blast3-dviewer>
    } @placeholder {
      <div class="d-flex justify-content-center align-items-center h-100">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading 3D viewer...</span>
        </div>
      </div>
    } @loading (minimum 300ms) {
      <div class="d-flex justify-content-center align-items-center h-100">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading 3D viewer...</span>
        </div>
      </div>
    }
  `,
  styles: [`
    :host {
      display: flex;
      flex-direction: column;
      flex: 1 1 0;
      width: 100%;
      min-height: 0;
    }
  `]
})
export class Blast3DViewerLazyComponent {
  @Input() tirId: number;
  /** Modèle géologique du tir, posé par la vue Géologie de l'onglet Trous. */
  readonly geologyModel = input<GeologyModel | null>(null);

  private readonly viewer = viewChild(Blast3DViewerComponent);

  /** Forwards a camera move to the viewer once it is loaded (no-op while deferred). */
  pan(dx: number, dy: number): void {
    this.viewer()?.pan(dx, dy);
  }

  /** Reloads the blast holes in the viewer once it is loaded (no-op while deferred). */
  reload(): void {
    this.viewer()?.reload();
  }
}
